interface WorkflowAvailability {
  isComingSoon?: boolean;
}

/** Counts visible workflows that users can start now. */
export const countAvailableWorkflows = (workflows: readonly WorkflowAvailability[]): number =>
  workflows.filter(({ isComingSoon }) => !isComingSoon).length;
